import { z } from '../zod.js';

export const FilePurposeValidationSchema = z.enum(['image', 'file']).meta({
  description:
    'Use `image` for public display assets such as page galleries, product galleries, ticket visuals, or similar media. Use `file` for private downloadable assets such as PDFs, digital downloads, or post-submission form downloads.',
});

export const UploadFileInputValidationSchema = z.object({
  url: z.url().meta({
    description:
      'Public URL of the file to fetch and upload into Checkout Page. The MCP tool downloads the file from this URL, then sends it to the Upload File API.',
  }),
  purpose: FilePurposeValidationSchema.default('image'),
  filename: z.string().optional().meta({
    description:
      'Optional filename override. If omitted, the tool derives a name from the source URL when possible.',
  }),
});
